// todo remove the mock api url
// ...
import TimePicker from 'rc-time-picker';
import React, { useEffect, useState } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import OutsideAlerter from './OutsideAlerter.jsx';

import moment from 'moment';
import MomentLocaleUtils from 'react-day-picker/moment';
import { getApi, isSuccessful } from '../../../../global/js/api';

// autocompleteApi={props.autocompleteApi}
// states={props.states}
// bookonlineTitle={props.bookonlineTitle}
// bookonlineDesc={props.bookonlineDesc}
const momentDateFormat = 'DD/MM/YYYY';

// https://bookabay.wilsonparking.com.au/public/flow.htm?&entryDD=29&entryMMYY=1220&entryHHMM=2100
/**
 *
 * @param {string} props.autocompleteApi
 * @param {array} props.states
 * @param {string} props.bookonlineTitle
 * @param {html} props.bookonlineDesc
 */
const BookOnlineBlock = (props) => {
  const [entryDate, setEntryDate] = useState('');
  const [exitDate, setExitDate] = useState('');
  const [entryTime, setEntryTime] = useState(null);
  const [exitTime, setExitTime] = useState(null);

  // for auto-complete search
  // const [keyword, setKeyword] = useState(props.bookOnlinePark);
  const [activeIndex, setActiveIndex] = useState(0);
  const [results, setResults] = useState([]);
  const [openResult, setOpenResult] = useState(false);

  // typing will trigger api
  const [callApi, setCallApi] = useState(false);

  const [canBookState, setCanBookState] = useState(false);
  const [showPromoCode, setShowPromoCode] = useState(false);
  const [promoCode, setPromoCode] = useState('');

  const format = 'HH:mm';

  // this is onchange func for search car parking input
  useEffect(() => {
    console.log(props.bookOnlinePark);
    if (props.bookOnlinePark.length < 3) {
      setOpenResult(false);
      return;
    }

    const timer = setTimeout(() => {
      if (callApi) {
        fetchSearch(props.bookOnlinePark);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [props.bookOnlinePark]);

  // this is onchange func for search car parking input
  useEffect(() => {
    if (canBook() == true) {
      setCanBookState(true);
    } else {
      setCanBookState(false);
      return;
    }
  }, [
    props.bookOnlineState,
    props.carParkCode,
    props.bookOnlinePark,
    entryDate,
    exitDate,
    entryTime,
    exitTime,
  ]);

  const canBook = () => {
    if (
      entryDate !== null &&
      exitDate !== null &&
      entryTime !== null &&
      exitTime !== null &&
      entryDate !== '' &&
      exitDate !== '' &&
      entryTime !== '' &&
      exitTime !== '' &&
      // carparkcode is number
      props.carParkCode > 0 &&
      props.bookOnlineState.length > 0 &&
      props.bookOnlinePark.length > 0
    ) {
      return true;
    }
    return false;
  };

  const updateCarParkCode = (url, carParkCodeValue) => {
    const urlObj = new URL(url);
    if (urlObj.searchParams.has('carParkCode')) {
      urlObj.searchParams.set('carParkCode', carParkCodeValue);
    } else {
      urlObj.searchParams.append('carParkCode', carParkCodeValue);
    }
    return urlObj.toString();
  };

  const bookNow = () => {
    // ('0' + MyDate.getDate()).slice(-2)
    let entryMMYY = moment(entryDate).format('MMYY');
    let entryDD = ('0' + entryDate.getUTCDate()).slice(-2);
    let entryHHMM = `${entryTime.split(':')[0]}${entryTime.split(':')[1]}`;

    let exitMMYY = moment(exitDate).format('MMYY');
    let exitDD = ('0' + exitDate.getUTCDate()).slice(-2);
    let exitHHMM = `${exitTime.split(':')[0]}${exitTime.split(':')[1]}`;

    let url = updateCarParkCode(props.bookABayUrl, props.carParkCode);
    url =
      url + `&entryDD=${entryDD}&entryMMYY=${entryMMYY}&entryHHMM=${entryHHMM}`;
    url = url + `&exitDD=${exitDD}&exitMMYY=${exitMMYY}&exitHHMM=${exitHHMM}`;
    url = url + `&state=${props.bookOnlineState}`;

    if (promoCode.length > 0) {
      url = url + `&voucherCode=${promoCode}`;
    }

    console.log(url);
    window.open(url, '_blank');
  };

  const setParkingScrollToAnchor = (el) => {
    let $target = $(`.simpleLocationSearchBar`);
    let delta = 0;
    let deltaAttr = $('.siteHeader').attr('data-sticky');
    if (typeof deltaAttr !== 'undefined' && deltaAttr !== 'false') {
      delta = $('.siteHeader').height();
    }
    let offsetHeader = $target.offset().top - delta * 2 - 16;
    console.log('offset', $target.offset().top);
    if ($target.length) {
      $('html, body').stop().animate(
        {
          scrollTop: offsetHeader,
        },
        1000
      );
    }
  };

  // this is func handling keyboard key
  const handleKey = (e) => {
    switch (e.key) {
      case 'Escape':
        setOpenResult(false);
        break;

      case 'Enter':
        setOpenResult(false);
        if (results[activeIndex]) {
          props.setBookOnlinePark(results[activeIndex].name);
          props.setBookOnlineState(results[activeIndex].state);
        }
        break;

      case 'ArrowUp':
        if (activeIndex - 1 >= 0) setActiveIndex(activeIndex - 1);
        break;

      case 'ArrowDown':
        if (activeIndex + 1 <= results.length - 1) {
          setActiveIndex(activeIndex + 1);
        }
        break;

      default:
        break;
    }
  };

  const fetchSearch = (keyword) => {
    setCallApi(false);

    let apiUrL = `${props.autocompleteApi}?keyword=${keyword}&state=${props.bookOnlineState}`;

    getApi(apiUrL).then((data) => {
      if (isSuccessful(data)) {
        console.log(data);
        let res = data.hits;
        if (res.length > 0) {
          setOpenResult(true);
          setResults(res);
        } else {
          console.log(res);
          return;
        }
      }
    });
  };

  const handleOpenPrepayModal = () => {
    const prepayModal = document.getElementById('prepayModal');
    if (prepayModal) {
      if (prepayModal.classList.contains('hidden')) {
        prepayModal.classList.remove('hidden');
      }
    }
  };

  const getElevateFeatures = (carParkFeature) => {
	const prepayCarParkFeature = window.prepayCarParkFeature; // E.g: 'Epark,Elevate Only,Prepay Online'
	if (!carParkFeature || !prepayCarParkFeature || carParkFeature.length === 0) return;
	const prepayFeaturesArray = prepayCarParkFeature.split(',');
	return prepayFeaturesArray.every((feature) => carParkFeature.includes(feature));
  };

  const handleClick = (item) => {
	setOpenResult(false);
    if (getElevateFeatures(item.carParkFeature)) {
      handleOpenPrepayModal();
      props.setBookOnlinePark('');
      props.setBookOnlineState('');
      props.setCarParkCode('');
      return;
    }
    props.setBookOnlinePark(item.name);
    props.setBookOnlineState(item.state);
    props.setCarParkCode(item.carParkCode);
  };

  return (
    <div className='bookOnlineBlock pt-6 border-bottom'>
      <div className=' container'>
        <h2>{props.bookonlineTitle}</h2>
        <div
          className='mb-5'
          dangerouslySetInnerHTML={{__html: `${props.bookonlineDesc}`}}
        ></div>
        <div className='row mb-5 form-group'>
          <div className='col-lg-2'>
            <label htmlFor='state'>State</label>
            <select
              value={props.bookOnlineState}
              onChange={(e) => props.setBookOnlineState(e.target.value)}
              className='form-control'
              name='stateSelect'
              id=''
            >
              {props.states &&
                props.states.map((e, i) => (
                  <option key={i} value={e}>
                    {e}
                  </option>
                ))}
            </select>
          </div>
          <div className='col-lg-4'>
            <label htmlFor='carpark'>Car park</label>
            {/* This is auto complete search for car park */}
            <input
              onChange={(e) => {
                setCallApi(true);
                props.setBookOnlinePark(e.target.value);
              }}
              onKeyDown={(e) => handleKey(e)}
              className='form-control'
              name='carpark'
              id='carpark'
              placeholder={props.bookonlinePlaceholder}
              value={props.bookOnlinePark}
              required=''
            ></input>

            {results.length > 0 && openResult && (
              <div className='bookOnlineBlock-results-wrapper'>
                <OutsideAlerter setOpenResult={setOpenResult}>
                  <div className='bookOnlineBlock-results'>
                    <ul className='bookOnlineBlock-searchList'>
                      {results.map((item, i) => (
                        <li
                          key={i}
                          className={i === activeIndex ? 'active' : ''}
                          onClick={() => handleClick(item)}
                        >
                          {item.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                </OutsideAlerter>
              </div>
            )}

            <a
              className='simpleLocationSearchBar-anchor'
              href='#'
              onClick={setParkingScrollToAnchor}
            >
              {props.bookonlineWheretofind}
            </a>
          </div>
        </div>
        <div className='row mb-5 form-group'>
          {/* entry date */}
          <div className='col-lg-3'>
            <span className='entry-label'></span>
            <label htmlFor='state'>Arrival date</label>
            <DayPickerInput
              inputProps={{
                className: 'form-control',
                name: 'entryDate',
                autoComplete: 'off',
                // 'onChange': handleChange,
                // 'onBlur': handleBlur,
                // 'aria-invalid': 'startDate' in errors,
              }}
              formatDate={MomentLocaleUtils.formatDate}
              parseDate={MomentLocaleUtils.parseDate}
              placeholder='DD/MM/YYYY'
              dayPickerProps={{
                locale: 'en-au',
                localeUtils: MomentLocaleUtils,
                firstDayOfWeek: 0,
                disabledDays: {
                  before: new Date(),
                  // after: this.props.maxDate,
                },
              }}
              // value={values.startDate}
              onDayChange={(day) => {
                if (day) {
                  setEntryDate(day);
                  setExitDate('');
                }
              }}
            />
          </div>
          {/* entry time */}
          <div className='col-lg-2'>
            <label htmlFor='state'>Time</label>
            <TimePicker
              // defaultValue={moment()}
              showSecond={false}
              onChange={(value) => {
                if (value) {
                  value = value.format(format);
                  setEntryTime(value);
                }
              }}
              use12Hours
              minuteStep={30}
              inputReadOnly
            />
          </div>
          {/* exit date */}
          <div className='col-lg-3 offset-lg-2'>
            <span className='exit-label'></span>
            <label htmlFor='state'>Exit date</label>
            <DayPickerInput
              inputProps={{
                className: 'form-control',
                name: 'exitDate',
                autoComplete: 'off',
                // 'onChange': handleChange,
                // 'onBlur': handleBlur,
                // 'aria-invalid': 'startDate' in errors,
              }}
              formatDate={MomentLocaleUtils.formatDate}
              parseDate={MomentLocaleUtils.parseDate}
              placeholder='DD/MM/YYYY'
              dayPickerProps={{
                locale: 'en-au',
                localeUtils: MomentLocaleUtils,
                firstDayOfWeek: 0,
                disabledDays: {
                  before: entryDate,
                  // after: this.props.maxDate,
                },
              }}
              value={exitDate}
              onDayChange={(day) => {
                if (day) {
                  setExitDate(day);
                }
              }}
            />
            <a href={props.stayLongerUrl}>{props.stayLongerText}</a>
          </div>
          {/* exit time */}
          <div className='col-lg-2'>
            <label htmlFor='state'>Time</label>
            <TimePicker
              // defaultValue={moment()}
              showSecond={false}
              onChange={(value) => {
                if (value) {
                  value = value.format(format);
                  setExitTime(value);
                }
              }}
              use12Hours
              minuteStep={30}
              inputReadOnly
            />
          </div>
        </div>
        <div className='row mb-5 form-group'>
          {!showPromoCode && (
            <div className='col-lg-3' onClick={() => setShowPromoCode(true)}>
              <label className='promo-label'></label>
              <span className='text-torch-red pointer font-weight-bold'>
                I have a promo code
              </span>
            </div>
          )}

          {showPromoCode && (
            <div className='col-lg-3'>
              <label htmlFor=''>Enter your promo code</label>
              <input
                onChange={(e) => {
                  setPromoCode(e.target.value);
                }}
                className='form-control promocode-input'
                placeholder=''
                value={promoCode}
                required=''
              />
            </div>
          )}

          <div className='col-lg-2 offset-lg-4 d-flex align-items-end'>
            <button
              disabled={!canBookState}
              onClick={bookNow}
              className='btn btn-primary w-100'
            >
              {props.submitButtonLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookOnlineBlock;
